<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <upload-view />
            </div>
        </div>
    </div>

</template>

<script>
import UploadView from "../views/upload-view";
export default {
name: "moodboard",
    components: { UploadView }
}
</script>

<style scoped>

</style>
